'use client'

import Link from 'next/link'
import { UserCircleIcon } from '@heroicons/react/24/outline'
import type { CreatorSuggestion } from './creatorSuggestions'

interface CreatorSuggestionListProps {
  suggestions: CreatorSuggestion[]
  activeIndex: number | null
  onClick: () => void
  onMouseEnter: (index: number) => void
  onMouseLeave: () => void
}

export function CreatorSuggestionList({
  suggestions,
  activeIndex,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: CreatorSuggestionListProps) {
  if (suggestions.length === 0) return null

  return (
    <div
      role="group"
      aria-label="Creator suggestions"
      className="border-b border-gray-200 py-2"
    >
      <p className="px-3 pb-1 text-xs font-semibold uppercase text-gray-500 lg:px-2">
        Creators
      </p>
      {suggestions.map((suggestion, index) => (
        <Link
          key={`${suggestion.name}-${suggestion.href}`}
          href={suggestion.href}
          prefetch={false}
          onClick={onClick}
          onMouseEnter={() => onMouseEnter(index)}
          onMouseLeave={onMouseLeave}
          className={`flex items-center gap-2 px-3 py-2 text-sm font-semibold text-gray-900 transition-colors lg:px-2 ${
            activeIndex === index ? 'bg-gray-100' : 'bg-white hover:bg-gray-50'
          }`}
        >
          <UserCircleIcon className="h-5 w-5 shrink-0 text-gray-500" />
          <span className="truncate">{suggestion.name}</span>
          <span className="ml-auto shrink-0 text-xs font-normal text-gray-500">
            View products
          </span>
        </Link>
      ))}
    </div>
  )
}
